import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { borderRadius, breakpoints, spacing } from '@naf/theme';
import { themeLight } from '@lib/nafTheme';
import { Tag } from '@naf-simba/elements-tag';
import { Link } from 'react-router-dom';
import { nafColor } from '@nafcore/theme';
import { isNotTransientProp } from '../../../lib/shouldForwardProp';

export const StyledText = styled(Text)`
  margin: 0;
  line-height: normal;

  @media (max-width: ${breakpoints.m}) {
    font-size: 1rem;
  }
`;

export const StyledLabel = styled(Tag)`
  position: absolute;
  top: -${spacing.space24};
  left: 0;
  white-space: nowrap;
`;

export const StyledImg = styled.img<{ $size: 'small' | 'large' }>`
  margin-right: ${spacing.space16};
  width: ${({ $size }) => ($size === 'small' ? '140px' : '160px')};
  height: ${({ $size }) => ($size === 'small' ? '100px' : '120px')};
  border-radius: ${borderRadius.S};
`;

export const ImgAndLabel = styled.div`
  position: relative;
  z-index: 1;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Ingress = styled(Text)`
  margin-top: ${spacing.space8};

  @media (max-width: ${breakpoints.s}) {
    display: none;
  }
`;

export const Wrapper = styled(Link, { shouldForwardProp: isNotTransientProp })<{
  $isActive: boolean;
  $showBorder?: boolean;
  $layout?: 'horizontal' | 'vertical';
  ref: any;
}>`
  display: flex;
  padding: ${spacing.space16};
  text-decoration: none;
  border-radius: ${borderRadius.L};
  scroll-snap-align: start;
  scroll-margin-left: 16px;
  scroll-margin-right: 16px;

  ${({ $layout }) =>
    $layout === 'horizontal'
      ? `
        flex: 0 0 auto;
        width: clamp(260px, 80vw, 340px);
        margin-right: ${spacing.space16};
        margin-top: ${spacing.space8};
      `
      : `
        width: 100%;
        margin-top: ${spacing.space8};
        margin-bottom: ${spacing.space8};
        box-sizing: border-box;
      `}

  ${({ $isActive }) => $isActive && `background-color: ${themeLight.background.brand};`}
  ${({ $showBorder, $isActive, $layout }) =>
    $showBorder && !$isActive && $layout === 'horizontal' && `border: 1px solid ${nafColor.neutral.neutral2};`}

  @media (max-width: ${breakpoints.m}) {
    ${({ $isActive }) => !$isActive && `border: 1px solid ${nafColor.neutral.neutral2};`}
  }
`;
